import React, { useState, useEffect, useContext } from "react";
import AuthContext from "../../Context/AuthContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList, faPlus } from "@fortawesome/free-solid-svg-icons";
import Form from "react-bootstrap/Form";
import { Link } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import QuestionnairesList from "../Components/QuestionnairesList";
import Dropdown from "react-bootstrap/Dropdown";
import Spinner from "react-bootstrap/Spinner";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import axios from "axios";
import { useTranslation } from "react-i18next";
import "./Questionnaires.css";

function Questionnaires() {
  const [isLoading, setIsLoading] = useState(true);
  const [questionnaires, setQuestionnaires] = useState([]);
  const [show, setShow] = useState(false);
  const [selectedOrganization, setSelectedOrganization] = useState("");
  const [selectedQuestionnaire, setSelectedQuestionnaire] = useState("");
  const [organizations, setOrganizations] = useState([]);

  const { state } = useContext(AuthContext);

  const { t } = useTranslation();

  useEffect(() => {
    async function fetch() {
      const response = await axios({
        method: "post",
        url: `${process.env.REACT_APP_BACKEND_URL}/questionnaires/organization/${state.organization}`,
        data: {
          language: state.language,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      setQuestionnaires(response.data.questionnaires);
      setOrganizations(response.data.organizations);
      setIsLoading(false);
    }
    fetch();
  }, [state.organization, state.token, state.language]);

  const handleClose = () => setShow(false);
  const handleShow = (id) => {
    setShow(true);
    setSelectedQuestionnaire(id);
  };

  const handleOrganizationChange = (e) => {
    setSelectedOrganization(e.target.value);
  };

  const cloneQuestionnaire = async (id) => {
    try {
      await axios({
        method: "post",
        url: `${process.env.REACT_APP_BACKEND_URL}/questionnaires/clone/`,
        data: {
          selectedOrganization: selectedOrganization,
          selectedQuestionnaire: selectedQuestionnaire,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      setShow(false);
    } catch (error) {
      console.log(error);
    }
  };

  if (isLoading === true) {
    return (
      <Spinner animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    );
  } else {
    return (
      <Container fluid>
        <Row className="align-items-center">
          <Col lg={10} className="questionnaires">
            <h2>{t("Cuestionarios.Titulo")}</h2>
          </Col>
          <Col lg={2} className="right questionnaires-content">
            <Dropdown>
              <Dropdown.Toggle id="dropdown-basic">
                <FontAwesomeIcon icon={faList} />
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item as={Link} to={`/questionnaires/new`}>
                  <FontAwesomeIcon icon={faPlus} />{" "}
                  {t("Cuestionarios.NuevoCuestionario")}
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Col>
        </Row>
        <Row>
          {questionnaires.length === 0 ? (
            <Col className="empty-questionnaires center">
              <h5>{t("Cuestionarios.SinCuestionarios")}</h5>
            </Col>
          ) : (
            <QuestionnairesList
              questionnaires={questionnaires}
              language={state.language}
              role={state.role}
              handleShow={handleShow}
            />
          )}
        </Row>
        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Seleccionar organizacion</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Select
              onChange={(e) => handleOrganizationChange(e)}
              value={selectedOrganization}
            >
              <option value="">Seleccionar organizacion</option>
              {organizations.map((org) => (
                <option key={org._id} value={org._id}>
                  {org.name}
                </option>
              ))}
            </Form.Select>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
            <Button
              variant="primary"
              onClick={() => cloneQuestionnaire(selectedOrganization)}
            >
              Clonar
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>
    );
  }
}

export default Questionnaires;
